import { ITrackable, Tracker } from './Tracker'

/**
 * Evalutes page for presence of various
 * Wordpress recipe card selectors.
 *
 */
export class RecipeCardTracker extends Tracker {
  private static plugins: Array<ITrackable> = [
    {
      name: 'ER',
      selectors: ['.ERSInstructionsHeader', '.ERSIngredients']
    },
    {
      name: 'MPP',
      selectors: ['#mpprecipe-ingredients', '#mprecipe-ingredients-list']
    },
    {
      name: 'WPUR',
      selectors: [
        '.wpurp-recipe-ingredient-group-container',
        '.wpurp-recipe-ingredient-container'
      ]
    },
    {
      name: 'Zip',
      selectors: [
        '#zlrecipe-ingredients',
        '#zlrecipe-instructions',
        '#zlrecipe-ingredients-list'
      ]
    },
    {
      name: 'Yum',
      selectors: ['#yrecipe-ingredients', '#yrecipe-ingredients-list']
    },
    {
      name: 'BYC',
      selectors: [
        '.blog-yumprint-ingredient-section',
        '.blog-yumprint-recipe-contents'
      ]
    },
    {
      name: 'SRP',
      selectors: ['.recipe-instructions-wrap', '.recipe-ingredients-wrap']
    },
    {
      name: 'WPRM',
      selectors: ['.wprm-recipe-ingredients-container']
    },
    {
      name: 'Tsty',
      selectors: ['.tasty-recipes-ingredients', '.tasty-recipe-ingredients']
    },
    {
      name: 'MVC',
      selectors: ['.mv-create-card']
    }
  ]

  constructor(
    readonly trackables = RecipeCardTracker.plugins,
    readonly _document: Document = document
  ) {
    super(trackables, _document)
  }

  get recipeCard(): string {
    if (this.multiple) {
      return 'multiple'
    }

    return this.presentTrackables[0]
  }

  private get multiple(): boolean {
    return this.presentTrackables.length > 1
  }
}
